'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import H1 from 'UIComponents/elements/headings/H1';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FeaturesSection from 'pricing-pages-unified-ui/components/free-tools-page/FeaturesSection';
import GuaranteeSection from 'pricing-pages-unified-ui/components/free-tools-page/GuaranteeSection';
import { FEATURES_SECTION } from 'pricing-pages-unified-ui/constants/Breakpoints';
import FooterMicrocopy from 'pricing-pages-unified-ui/components/common/FooterMicrocopy';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { SCREENS, SUBSCREENS } from 'pricing-pages-unified-ui/constants/Tracking';
import Question from 'pricing-pages-unified-ui/components/common/Question';
import { withRouter } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import TabLayout from '../tabs/TabLayout';
import breakpoint from '../../utils/responsiveBreakpoints';
import EnvironmentWrapper from 'pricing-pages-unified-ui/components/EnvironmentWrapper';
import SignupButton from 'pricing-pages-unified-ui/components/public-only/SignupButton';
import { withDocumentTitle } from 'pricing-pages-unified-ui/utils/DocumentUtils';
import PhoneSupport from 'pricing-pages-unified-ui/components/common/PhoneSupport';
import { GYPSUM } from 'HubStyleTokens/colors';
import SkeletonLoadWrapper from '../loading/SkeletonLoadWrapper';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { TabEnum } from '../../constants/TabConfig';
import { getLanguagesUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getAcademyUrlPublic, getProductAndServicesUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import Faq from 'pricing-pages-unified-ui/components/common/Faq';
import { useTrackRetail } from '../../selectors/RetailSelectors';
import { isMon606InAppRunningForPublicUserSelector, isMon606VariantSelector, useMon606LogExposure } from '../../selectors/ExperimentTreatmentSelectors';
import { getMon606TextKeyBase } from '../../utils/mon606Utils'; // import { useFeatureStore } from '../../hooks/useFeatureStore';
// import { getAllFreeProducts } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
// import FeaturesSectionFS from './FeaturesSectionFS';
// import { isUngatedForFeatureStore } from '../../selectors/GatingSelectors';

const Container = styled.div.withConfig({
  displayName: "FreeToolsPage__Container",
  componentId: "sc-1to50p0-0"
})(["background-color:white;display:flex;align-items:center;flex-direction:column;overflow:hidden;width:100%;position:relative;"]);
const MainHeader = styled(FormattedMessage).withConfig({
  displayName: "FreeToolsPage__MainHeader",
  componentId: "sc-1to50p0-1"
})(["text-align:center;font-weight:600;font-size:32px;margin-bottom:20px;line-height:40px;@media (max-width:", "px){font-size:29px;}"], FEATURES_SECTION);
const SubHeader = styled(FormattedMessage).withConfig({
  displayName: "FreeToolsPage__SubHeader",
  componentId: "sc-1to50p0-2"
})(["font-weight:300;font-size:14px;text-align:center;max-width:800px;@media (max-width:", "px){font-size:16px;}"], FEATURES_SECTION);
const PhoneSupportWrapper = styled.div.withConfig({
  displayName: "FreeToolsPage__PhoneSupportWrapper",
  componentId: "sc-1to50p0-3"
})(["width:450px;margin-top:40px;", ""], breakpoint.phone(_t || (_t = _`
    width: 100%;
    margin-top: 0;
    background-color: ${0};
    padding-bottom: 3.4em;
  `), GYPSUM));
const Taglines = styled(H1).withConfig({
  displayName: "FreeToolsPage__Taglines",
  componentId: "sc-1to50p0-4"
})(["text-align:center;margin:1.55em 0 0.74em;", " .tagline{display:block;}"], breakpoint.phone(_t2 || (_t2 = _`
    padding: 0 0.45em;
    text-align: left;
  `)));
const SignupButtonWrapper = styled.div.withConfig({
  displayName: "FreeToolsPage__SignupButtonWrapper",
  componentId: "sc-1to50p0-5"
})(["", ""], breakpoint.phone(_t3 || (_t3 = _`
    width: 90%;
  `)));

const FreeToolsPage = () => {
  useTrackRetail();
  useMon606LogExposure();
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.PRODUCTS_PLANS,
      subscreen: SUBSCREENS.FREE_TOOLS_CRM
    });
  }, []);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isMon606Variant = useSelector(isMon606VariantSelector);
  const isMon606InAppRunningForPublicUser = useSelector(isMon606InAppRunningForPublicUserSelector);
  const showMon606VariantText = !isMon606InAppRunningForPublicUser && isMon606Variant;
  const Mon606TextKeyBase = getMon606TextKeyBase(showMon606VariantText); // const allFreeProducts = getAllFreeProducts();
  // useFeatureStore({ highlightedProducts: allFreeProducts });
  // const isUngatedForFS = useSelector(isUngatedForFeatureStore);

  return /*#__PURE__*/_jsx(TabLayout, {
    selectedPrimaryTab: "products",
    selectedSecondaryTab: TabEnum.CRM,
    children: /*#__PURE__*/_jsxs(Container, {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "FREE_TOOLS_PAGE"
      }), /*#__PURE__*/_jsxs("div", {
        className: "display-flex align-center flex-column p-x-4",
        style: {
          maxWidth: '850px',
          paddingTop: '50px',
          paddingBottom: '50px'
        },
        children: [/*#__PURE__*/_jsx(MainHeader, {
          message: 'pricingPage.pages.crm.mainHeader'
        }), /*#__PURE__*/_jsx(SubHeader, {
          message: `${Mon606TextKeyBase}.pages.crm.subHeader`
        }), /*#__PURE__*/_jsx(EnvironmentWrapper, {
          publicNode: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
            widths: [200],
            heights: [56],
            className: "m-top-5",
            isLoading: !hasPricingAndPurchasingSucceeded,
            children: /*#__PURE__*/_jsx(SignupButton, {
              sourceId: "pricing-hero",
              productLine: "crm",
              className: "p-x-9 p-y-5 m-top-5",
              ctaKey: 'pricingPage.signupCtas.getStartedFree'
            })
          })
        })]
      }), /*#__PURE__*/_jsx(FeaturesSection, {}), /*#__PURE__*/_jsx(GuaranteeSection, {}), /*#__PURE__*/_jsx(PhoneSupportWrapper, {
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          phoneSourceId: "crm-middle",
          screen: SUBSCREENS.FREE_TOOLS_CRM
        })
      }), /*#__PURE__*/_jsxs(Faq, {
        children: [/*#__PURE__*/_jsx(Question, {
          questionKey: "free.crmReallyFree411"
        }), /*#__PURE__*/_jsx(Question, {
          questionKey: "free.whatAreLimits411",
          href: getProductAndServicesUrlPublic()
        }), /*#__PURE__*/_jsx(Question, {
          questionKey: "free.emailIntegration411"
        }), /*#__PURE__*/_jsx(Question, {
          questionKey: "free.whatIsAUser411"
        }), /*#__PURE__*/_jsx(Question, {
          questionKey: "free.howManyContacts411"
        }), /*#__PURE__*/_jsx(Question, {
          questionKey: "free.whatSupport411",
          passedInOptions: {
            communityHref: getCommunityUrlPublic(),
            academyHref: getAcademyUrlPublic(),
            kbHref: getKnowledgeBaseUrlPublic(),
            langHref: getLanguagesUrlPublic(),
            onLinkClick: url => {
              getUsageTracker().track('externalLinkClick', {
                name: 'faq-click-link',
                url
              });
            }
          }
        }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
      }), /*#__PURE__*/_jsx(EnvironmentWrapper, {
        publicNode: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Taglines, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              className: "tagline",
              message: "pricingPage.pages.crm.mainHeader"
            })
          }), /*#__PURE__*/_jsx(SignupButtonWrapper, {
            children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
              widths: [200],
              heights: [56],
              className: "m-bottom-8",
              isLoading: !hasPricingAndPurchasingSucceeded,
              children: /*#__PURE__*/_jsx(SignupButton, {
                sourceId: "pricing-bottom",
                productLine: "crm",
                className: "p-x-9 p-y-5 m-top-5 m-bottom-8",
                ctaKey: 'pricingPage.signupCtas.getStartedFree'
              })
            })
          })]
        })
      })]
    })
  });
};

export default withRouter(withDocumentTitle(FreeToolsPage, 'free'));